// Vue3
import { createApp } from 'vue';
import App from '@/App.vue';
// Vue-Router
import router from '@router/RouterService.js';
// Toastification
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
// Boostrap 5
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
// SCSS (Propio)
import '../public/styles/main.scss';
import '../public/styles/variables.scss';
// DayJS
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import relativeTime from 'dayjs/plugin/relativeTime';
import isoWeek from 'dayjs/plugin/isoWeek';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.locale('es');
dayjs.extend(relativeTime);
dayjs.extend(isoWeek);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(isSameOrAfter);

// ######## Base ########
const app = createApp(App);
// ######## Toastification ########
app.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 10,
  newestOnTop: true,
  filterBeforeCreate: (toast, toasts) => {
    const isDuplicate = toasts.some((t) => t.type === toast.type && t.content === toast.content);
    if (isDuplicate) {
      return false;
    }
    return toast;
  },
});
// ######## DayJS ########
app.provide('dayjs', dayjs);
// ######## Router + Mount ########
app.use(router).mount('#app');
